<template>
  <div>
    <div>
      <router-link to="/">Home </router-link>
      <label class="labelBar"> / </label>
      <router-link to="/modelo"> Cadastro/Equipamento/Modelos </router-link>
      <label class="labelBar"> / </label>
      <label v-if="!readOnly"> Editar</label>
      <label v-else> Ver</label>
    </div>
    <tab-navegacao-equipamento />
    <v-container fluid>
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-row align="center">
          <v-col col="6">
            <v-text-field
              label="Descrição *"
              v-model="descricao"
              v-uppercase
              :counter="200"
              :readonly="readOnly"
              :rules="[(v) => !!v || 'A Descrição é obrigatória']"
              required
            ></v-text-field>
          </v-col>
          <v-col col="6">
            <v-select
              v-model="marcaEquipamentoSelected"
              :items="findMarcasAtivas"
              label="Marca Equipamento *"
              item-text="descricao"
              item-value="id"
              persistent-hint
              return-object
              :readonly="readOnly"
              :rules="[(v) => !!v || 'A marca do equipamento é obrigatória']"
              required
            >
            </v-select>
          </v-col>
        </v-row>
      </v-form>
      <v-row align="center-left">
        <v-col cols="12" sm="6">
          <v-checkbox v-model="modelo.ativo" label="Ativo" :readonly="readOnly"></v-checkbox>
        </v-col>
        <v-col cols="12" sm="6" class="text-right">
          <v-btn to="/modelo" color="error" class="mr-4" v-if="!readOnly">
            Voltar
          </v-btn>
          <v-btn to="/modelo" color="success" class="mr-4" v-else>
            Voltar
          </v-btn>
          <v-btn @click="enviar" color="success" class="mr-4" v-if="!readOnly">
            Salvar
          </v-btn>
        </v-col>
      </v-row>
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </v-container>
  </div>
</template>

<script>
import TabNavegacaoEquipamento from "../../Tabs/TabCadastroEquipamento";
import { editarModeloAsync } from "../../../services/modeloService";
import { mapState, mapActions } from "vuex";
import { getUserPermission } from "@/services/loginService";

export default {
  name: "editarModelo",
  data: () => ({
    overlay: false,
    valid: true,
    descricao: null,
    marcaEquipamentoSelected: null,
    readOnly: false,
  }),
  computed: {
    ...mapState("modelo", ["modelo", "modelos"]),
    ...mapState("marcaEquipamento", ["marcaEquipamento", "marcaEquipamentos"]),

    findMarcasAtivas() {
      return this.marcaEquipamentos.filter((m) => {
        return m.ativo === true;
      });
    }

  },
  methods: {
    ...mapActions("modelo", ["atualizarModelos"]),
    async enviar() {
      if (this.$refs.form.validate()) {
        this.overlay = true;
        const resposta = await editarModeloAsync(
          this.modelo.id,
          this.descricao,
          this.marcaEquipamentoSelected.id,
          this.modelo.ativo
        );
        if (resposta) {
          this.overlay = false;
          this.$alert(resposta.message, "Desculpe, falha na operação!", "error");
        } else {
          this.overlay = false;
          this.$router.push("/modelo");
        }
      }
    },
    findMarcaEquipamento(marcaId) {
      return this.marcaEquipamentos.find((me) => me.id === marcaId && me.ativo === true);
    },
    doAjax() {
      this.atualizarModelos();
    },
  },
  created: function () {
    this.doAjax();
    this.readOnly = !getUserPermission(7);
    this.descricao = this.modelo.descricao;
    this.marcaEquipamentoSelected = this.findMarcaEquipamento(this.modelo.idMarcaEquipamento);
  },
  components: {
    TabNavegacaoEquipamento,
  },
};
</script>